import React from 'react'

import Select from 'components/Select'

const SelectFilter = (passedProps) => {
  const {filter, onChangeSelectFilter, tasteProfiles, ...otherProps} = passedProps
  const {name, options} = filter
  const props = {
    ...otherProps,
    options,
    name,
    onChange: (event) => onChangeSelectFilter(event, filter, tasteProfiles)
  }
  return <Select {...props} />
}

export default SelectFilter
